import { render, staticRenderFns } from "./FunctionDemo.vue?vue&type=template&id=5b03c853&scoped=true"
import script from "./FunctionDemo.vue?vue&type=script&lang=js"
export * from "./FunctionDemo.vue?vue&type=script&lang=js"
import style0 from "./FunctionDemo.vue?vue&type=style&index=0&id=5b03c853&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b03c853",
  null
  
)

export default component.exports